import { render, staticRenderFns } from "./ProcurementInventory.vue?vue&type=template&id=62f7ee58&"
import script from "./ProcurementInventory.vue?vue&type=script&lang=js&"
export * from "./ProcurementInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports